import { actionTypeCreator } from './util'

// ////////////////////////////////////////////////////////////////////////// //
// Constants
// ////////////////////////////////////////////////////////////////////////// //
export const constants = {
  NAME: 'error'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(null, constants.NAME)
export const DISPLAY_ERROR = createActionType('DISPLAY_ERROR')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function display (error) {
  return {
    type: DISPLAY_ERROR,
    payload: error,
    error: true
  }
}

// ////////////////////////////////////////////////////////////////////////// //
// Reducer
// ////////////////////////////////////////////////////////////////////////// //
const initialState = {
  message: '',
  count: 0
}

export function reducer (state = initialState, action = {}) {
  if (action.error && action.payload) {
    return {
      message: action.payload,
      count: state.count + 1
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/redux/modules/error.js